import "./assests/styles/main.css";
import { Routes, Route } from "react-router-dom";

import PublicRoute from "./routes/public.js";
import PrivateRoute from "./routes/private.js";

import HomePage from "./pages/public/home.js";
import GoalPage from "./pages/public/goals.js";
import FounderPage from "./pages/public/founders.js";
import VishwasthaPage from "./pages/public/vishwasthaMandal.js";
import VidyamanPage from "./pages/public/vidyamanMandal.js";
import UpakramPage from "./pages/public/upakram.js";
import HallPage from "./pages/public/hall.js";
import ComputerPage from "./pages/public/computer.js";
import ContactUsPage from "./pages/public/contactus.js";
import PhotosPage from "./pages/public/photos.js";
import AhavalPage from "./pages/public/ahaval.js";
import LoginPage from "./pages/admin/login.js";

import AdminHomePage from "./pages/admin/home";
import CreateLoginPage from "./pages/admin/createLogin";
import ChangePasswordPage from "./pages/admin/changePassword";
import AdminWedgitsPage from "./pages/admin/wedgits.js";
import AdminHallPage from "./pages/admin/hall.js";
import AdminGoalPage from "./pages/admin/goals";
import AdminUpakramPage from "./pages/admin/upakram";
import AdminComputerPage from "./pages/admin/computer";
import AdminPhotosPage from "./pages/admin/photos.js";
import AdminPhotosTypePage from "./pages/admin/photoType.js";
import AdminFounderPage from "./pages/admin/founder";
import AdminVishwasthaPage from "./pages/admin/vishwasthaMandal";
import AdminVidyamanPage from "./pages/admin/vidyamanMandal";
import AdminAhavalPage from "./pages/admin/ahaval";
import CommitteePage from "./pages/admin/committee";
import SliderPage from "./pages/admin/slider";
import SiteSettingPage from "./pages/admin/siteSetting";
import SearchMemberPage from "./pages/admin/searchMember";
import CreateMemberPage from "./pages/admin/saveMember";
import ReportPage from "./pages/admin/report.js";
import MessagePage from "./pages/admin/sendMessage.js";
import SimpleSlider from "./pages/test.js";

function App() {
  return (
    
    <Routes>
      {/* <AnonymousRoute /> */}
      <Route element={<PublicRoute />}>
        <Route>
          <Route path="/" element={<HomePage />} />
          <Route path="/goals" element={<GoalPage />} />
          <Route path="/founders" element={<FounderPage />} />
          <Route path="/vishwasthamandals" element={<VishwasthaPage />} />
          <Route path="/vidyamanmandals" element={<VidyamanPage />} />
          <Route path="/upakram" element={<UpakramPage />} />
          <Route path="/halls" element={<HallPage />} />
          <Route path="/computers" element={<ComputerPage />} />
          <Route path="/photos" element={<PhotosPage />} />
          <Route path="/ahaval" element={<AhavalPage />} />
          <Route path="/contactus" element={<ContactUsPage />} />
          <Route path="/admin/login" element={<LoginPage />} />
          <Route path="/test" element={<SimpleSlider />} />
        </Route>
      </Route>

      {/* <AdminRoute /> */}
      <Route element={<PrivateRoute />}>
        <Route path="/admin" element={<AdminHomePage />} />
        <Route path="/admin/committee" element={<CommitteePage />} />
        <Route path="/admin/createlogin" element={<CreateLoginPage />} />
        <Route path="/admin/changepassword" element={<ChangePasswordPage />} />
        <Route path="/admin/wedgits" element={<AdminWedgitsPage />} />
        <Route path="/admin/hall" element={<AdminHallPage />} />
        <Route path="/admin/goals" element={<AdminGoalPage />} />
        <Route path="/admin/upakram" element={<AdminUpakramPage />} />
        <Route path="/admin/computers" element={<AdminComputerPage />} />
        <Route path="/admin/photos" element={<AdminPhotosPage />} />
        <Route path="/admin/phototype" element={<AdminPhotosTypePage />} />
        <Route path="/admin/founders" element={<AdminFounderPage />} />
        <Route
          path="/admin/vishwasthamandal"
          element={<AdminVishwasthaPage />}
        />
        <Route path="/admin/vidyamanmandal" element={<AdminVidyamanPage />} />
        <Route path="/admin/ahaval" element={<AdminAhavalPage />} />
        <Route path="/admin/sitesetting" element={<SiteSettingPage />} />
        <Route path="/admin/slider" element={<SliderPage />} />
        <Route path="/admin/searchmember" element={<SearchMemberPage />} />
        <Route path="/admin/savemember" element={<CreateMemberPage />} />
        <Route path="/admin/report" element={<ReportPage />} />
        <Route path="/admin/sendmessage" element={<MessagePage />} />
      </Route>
    </Routes>
    
  );
}

export default App;
